import { render, staticRenderFns } from "./LoginPopupAccountGm99.vue?vue&type=template&id=2a4bacbb&scoped=true&"
import script from "./LoginPopupAccountGm99.vue?vue&type=script&lang=js&"
export * from "./LoginPopupAccountGm99.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopupAccountGm99.vue?vue&type=style&index=0&id=2a4bacbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bacbb",
  null
  
)

component.options.__file = "LoginPopupAccountGm99.vue"
export default component.exports